import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';

import { FormlyInputComponent } from './components/formly/formly-input/formly-input.component';
import { FormlyInputSearchComponent } from './components/formly/formly-input-search/formly-input-search.component';
import { FormlyTextAreaComponent } from './components/formly/formly-text-area/formly-text-area.component';
import { FormlyRecipientsComponent } from './components/formly/formly-recipients/formly-recipients.component';
import { FormlyRichTextComponent } from './components/formly/formly-rich-text/formly-rich-text.component';
import { FormlyDateComponent } from './components/formly/formly-date/formly-date.component';
import { FormlySelectComponent } from './components/formly/formly-select/formly-select.component';
import { FormlyCheckboxComponent } from './components/formly/formly-checkbox/formly-checkbox.component';
import { FormlyRadioComponent } from './components/formly/formly-radio/formly-radio.component';
import { FormlyFileUploadComponent } from './components/formly/formly-file-upload/formly-file-upload.component';
import { FormlyAddressLookupComponent } from './components/formly/formly-address-lookup/formly-address-lookup.component';
import { FormlyButtonComponent } from './components/formly/formly-button/formly-button.component';
import { FormlyBackButtonComponent } from './components/formly/formly-back-button/formly-back-button.component';
import { FormlyImportButtonComponent } from './components/formly/formly-import-button/formly-import-button.component';
import { FormlyTemplateComponent } from './components/formly/formly-template/formly-template.component';
import { FormlyFieldsComponent } from './components/formly/formly-fields/formly-fields.component';
import { FormlyWarpWeftPlanComponent } from './components/formly/formly-warp-weft-plan/formly-warp-weft-plan.component';
import { FormlyArrayComponent } from './components/formly/formly-array/formly-array.component';
import { FormlySummaryComponent } from './components/formly/formly-summary/formly-summary.component';
import { FormlyRepeatComponent } from './components/formly/formly-repeat/formly-repeat.component';
import { FormlyLineBreakComponent } from './components/formly/formly-line-break/formly-line-break.component';
import { FormlyHorizontalWrapperComponent } from './components/formly/wrappers/horizontal-wrapper/horizontal-wrapper.component';
import { FormlyInlineWrapperComponent } from './components/formly/wrappers/inline-wrapper/inline-wrapper.component';

export const TmsFormlyConfig: ConfigOption = {
  types: [
    {
      name: 'input',
      component: FormlyInputComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'input-search',
      component: FormlyInputSearchComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'textarea',
      component: FormlyTextAreaComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'rich-text',
      component: FormlyRichTextComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'recipients',
      component: FormlyRecipientsComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'date',
      component: FormlyDateComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'select',
      component: FormlySelectComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'checkbox',
      component: FormlyCheckboxComponent,
      wrappers: ['form-field'],
    },
    {
      name: 'radio',
      component: FormlyRadioComponent,
      wrappers: ['form-field'],
    },
    {
      component: FormlyFileUploadComponent,
      name: 'file-upload',
      wrappers: ['form-field'],
    },
    {
      component: FormlyAddressLookupComponent,
      name: 'address-lookup',
      wrappers: ['form-field'],
    },
    {
      component: FormlyButtonComponent,
      name: 'button',
      wrappers: ['form-field'],
    },
    {
      component: FormlyBackButtonComponent,
      name: 'back-button',
      wrappers: ['form-field'],
    },
    {
      component: FormlyImportButtonComponent,
      name: 'import-button',
      wrappers: ['form-field'],
    },
    {
      component: FormlyTemplateComponent,
      name: 'template',
      wrappers: ['form-field'],
    },
    {
      component: FormlyFieldsComponent,
      name: 'fields',
      wrappers: ['form-field'],
    },
    {
      component: FormlyWarpWeftPlanComponent,
      name: 'warp-weft-plan',
      wrappers: [],
    },
    {
      component: FormlyArrayComponent,
      name: 'array',
      wrappers: [],
    },
    {
      component: FormlySummaryComponent,
      name: 'summary',
      wrappers: [],
    },
    {
      component: FormlyRepeatComponent,
      name: 'repeat',
      wrappers: [],
    },
    {
      component: FormlyLineBreakComponent,
      name: 'line-break',
      wrappers: [],
    },
  ],
  wrappers: [
    { name: 'form-field', component: FormlyHorizontalWrapperComponent },
    { name: 'inline', component: FormlyInlineWrapperComponent },
  ],
  validationMessages: [
    { name: 'required', message: requiredValidationMessage },
    { name: 'minLength', message: minLengthValidationMessage },
    { name: 'maxLength', message: maxLengthValidationMessage },
    { name: 'min', message: minValidationMessage },
    { name: 'max', message: maxValidationMessage },
    { name: 'lessThan', message: lessThanValidationMessage },
    { name: 'greaterThan', message: greaterThanValidationMessage },
    { name: 'lessThanOrEqual', message: lessThanOrEqualValidationMessage },
    { name: 'greaterThanOrEqual', message: greaterThanOrEqualValidationMessage },
    { name: 'email', message: emailValidationMessage },
    { name: 'postcode', message: postcodeValidationMessage },
    { name: 'percentage', message: percentageValidationMessage },
    { name: 'integer', message: integerValidationMessage },
    { name: 'date', message: dateValidationMessage },
    { name: 'containsUppercase', message: containsUppercaseValidationMessage },
    { name: 'containsLowercase', message: containsLowercaseValidationMessage },
    { name: 'containsNumbers', message: containsNumbersValidationMessage },
    { name: 'containsNonAlphaNumeric', message: containsNonAlphaNumericValidationMessage },
    { name: 'notExists', message: notExistsValidationMessage },
  ],
};

export function requiredValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} is required`;
}

export function minLengthValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} should have at least ${error.requiredLength} characters`;
}

export function maxLengthValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} should be less than ${error.requiredLength} characters`;
}

export function minValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} should be a minimum of ${error.min}`;
}

export function maxValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} should be a maximum of ${error.max}`;
}

export function lessThanValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} should be less than ${field.formControl.errors.lessThan}`;
}

export function greaterThanValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} should be greater than ${field.formControl.errors.greaterThan}`;
}

export function lessThanOrEqualValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} should be a maximum of ${field.formControl.errors.lessThanOrEqual}`;
}

export function greaterThanOrEqualValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} should be a minimum of ${field.formControl.errors.greaterThanOrEqual}`;
}

export function emailValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} is not a valid email address`;
}

export function postcodeValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} is not a valid postcode`;
}

export function percentageValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} is not a valid percentage`;
}

export function integerValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} must be a whole number`;
}

export function dateValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} is not a valid date`;
}

export function containsUppercaseValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} must contain at least one uppercase letter`;
}

export function containsLowercaseValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} must contain at least one lowercase letter`;
}

export function containsNonAlphaNumericValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} must contain at least one special character`;
}

export function containsNumbersValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} must contain at least one number`;
}

export function notExistsValidationMessage(error, field: FormlyFieldConfig): string {
  return `${getFieldName(field)} already exists`;
}

export function getFieldName(field: FormlyFieldConfig): string {
  return field.props.label ?? field.key.toString();
}
